import { LeoDate, LeoTimestamp } from "@surya-digital/leo-ts-runtime";

export const getLocalDateString = (date: Date): string =>
  [
    date.getFullYear(),
    (date.getMonth() + 1).toString().padStart(2, "0"),
    date.getDate().toString().padStart(2, "0"),
  ].join("-");

export const parseLocalDateString = (dateString: string): Date => {
  const [year, month, day] = dateString.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const getStartOfToday = (): Date => {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate());
};

export const getFormattedLeoDate = (date: Date | undefined | null): LeoDate => {
  if (date) {
    return new LeoDate(getLocalDateString(date));
  } else {
    // If date is undefined or null then LeoDate returns current date.
    return new LeoDate();
  }
};

export const getFormattedLeoTimeStamp = (
  date: Date | undefined | null,
): LeoTimestamp => {
  if (date) {
    const offsetInMilliSeconds = date.getTimezoneOffset() * 60000;
    const temp = new LeoTimestamp(
      new Date(date.getTime() - offsetInMilliSeconds).toISOString(),
    );
    return temp;
  } else {
    // If date is undefined or null then LeoTimestamp returns current timestamp.
    return new LeoTimestamp();
  }
};

export const convertTimestampFormat = (timestamp: string): string => {
  const date = new Date(timestamp);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
};
